<template>
    <button
        :type="buttonType"
        :title="title"
        class="btn"
        :class="classes"
        :disabled="btnDisabled"
        v-if="htmlType == 'button'"
    >
        <ButtonIcon :buttonClass="buttonClass" :loading="loading" :text="text" />
    </button>

    <Link
        :href="href"
        :title="title"
        class="btn no-underline"
        :class="classes, {'disabled-link': btnDisabled}"
        v-else-if="htmlType == 'a' && linkType == 'inertia'"
    >
        <ButtonIcon :buttonClass="buttonClass" :loading="loading" :text="text" />
    </Link>

    <a
        :href="href"
        :title="title"
        class="btn no-underline"
        :class="classes, {'disabled-link': btnDisabled}"
        v-else
    >
        <ButtonIcon :buttonClass="buttonClass" :loading="loading" :text="text" />
    </a>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';
import ButtonIcon from "./ButtonIcon";

export default {
    components: {
        ButtonIcon,
        Link,
    },
    props: {
        text: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: (props) => props.text
        },
        htmlType: {
            type: String,
            default: 'button'//a
        },
        buttonType: {
            type: String,
            default: 'button',//submit, reset
        },
        buttonClass: {
            type: String,
            default: 'primary',//primary, secondary, default, info, alt, danger, success, save, delete, edit, show, ...
        },
        linkType: {
            type: String,
            default: 'inertia',//regular, normal, anything but inertia
        },
        size: {
            type: String,
            default: 'default',//small
        },
        href: {
            type: String,
        },
        loading: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            btnDisabled: (this.disabled == true || this.loading == true) ? true : false,
            defaultBtnClasses: this.buttonClasses + ' bg-blue-dark-500 inline-block whitespace-nowrap text-white text-center font-bold rounded-md hover:transition hover:bg-opacity-75',
        }
    },
    created() {
        let classes =  ' btn py-2 mr-3 mb-2';

        //If we have no text, center the icon
        if (this.text == '')
        {
            classes += " pl-2 pr-1"
        }
        else
        {
            classes += " pl-3"
        }

        switch (this.size) {
            case "small":
                this.defaultBtnClasses += " btn small pl-1 py-0.5 mr-1 mb-1 text-sm"
                break;
            default:
                this.defaultBtnClasses += classes
                break;
        }

        this.btnText();
    },
    methods: {
        btnText() {
            //Check if default slot has text
            if (this.text != null && this.text != '') {
                //If so, set padding
                if (this.size == 'small') {
                    this.defaultBtnClasses += " pr-1";
                } else {
                    this.defaultBtnClasses += " pr-3";
                }
            }
        }
    },
    computed: {
        classes() {

            let btnClasses = this.defaultBtnClasses

            this.buttonClass.split("-").forEach(function(className) {
                switch (className) {
                    case "primary"://To overwrite a bg-color to the default btn color
                        btnClasses += ' !bg-blue-dark-500';
                        break;
                    case "secondary":
                        btnClasses = btnClasses.replace('bg-blue-dark-500', '')
                        btnClasses += ' bg-yellow-500';
                        break;
                    case "info":
                        btnClasses = btnClasses.replace('bg-blue-dark-500', '')
                        btnClasses += ' bg-blue-light-500';
                        break;
                    case "alt":
                        btnClasses = btnClasses.replace('bg-blue-dark-500', '')
                        btnClasses += ' bg-white text-blue-dark-500 border border-blue-dark-500 hover:bg-blue-dark-500 hover:text-white hover:opacity-100';
                        break;
                    case "danger":
                    case "delete":
                    case "cancel":
                        btnClasses = btnClasses.replace('bg-blue-dark-500', '')
                        btnClasses += ' bg-red-600';
                        break;
                    case "block":
                    case "warning":
                        btnClasses = btnClasses.replace('bg-blue-dark-500', '')
                        btnClasses += ' bg-orange-500'
                        break;
                    case "success":
                    case "approve":
                        btnClasses = btnClasses.replace('bg-blue-dark-500', '')
                        btnClasses += ' bg-green-500';
                        break;
                    case "save":
                    case "edit":
                    case "add":
                    case "purple":
                        btnClasses = btnClasses.replace('bg-blue-dark-500', '')
                        btnClasses += ' bg-purple-500';
                        break;
                    default:
                        break;
                }
            })

            return btnClasses

            // switch (this.buttonClass) {
            //     case "primary":
            //     case "save":
            //     case "edit":
            //     case "previous":
            //     case "next":
            //     case "filter":
            //     case "add":
            //     case "send":
            //     case "details":
            //     case "search":
            //     case "show":
            //     case "download":
            //     case "retry":
            //     case "settings":
            //         return this.defaultBtnClasses + ' bg-blue-dark-500';
            //         break;
            //     case "secondary":
            //     case "logout":
            //         return this.defaultBtnClasses + ' bg-yellow-500';
            //         break;
            //     case "info":
            //         return this.defaultBtnClasses + ' bg-blue-light-500';
            //         break;
            //     case "alt":
            //         return this.defaultBtnClasses + ' bg-white text-blue-dark-500 border border-blue-dark-500 hover:bg-blue-dark-500 hover:text-white hover:opacity-100';
            //         break;
            //     case "danger":
            //     case "delete":
            //     case "cancel":
            //         return this.defaultBtnClasses + ' bg-red-600';
            //         break;
            //     case "success":
            //     case "approve":
            //     case "login":
            //         return this.defaultBtnClasses + ' bg-green-500';
            //         break;
            //     default:
            //         return this.defaultBtnClasses + ' bg-purple-500';
            //         break;
            // }
        },
        hasText() {
            // Check if we have button text
            // return !!this.$slots['default'] || !!this.$scopedSlots['default'];
            return this.$slots.default;
        }
    },
    watch: {
        disabled: function(disabled) {
            //Check if disabled property changes
            this.btnDisabled = disabled
        },
        loading: function(loading) {
            //Check if disabled property changes
            this.btnDisabled = loading
        }
    }
}
</script>

<style>
.btn:last-child {
    margin-right: 0;
}

.btn:disabled,
.btn.disabled-link {
    cursor: not-allowed;
    opacity: 0.75;
}

.btn.disabled-link {
    pointer-events: none;
}
</style>
